module.exports = __webpack_public_path__ + "media/images/desktop/close-circle-d0e2b7b4842c5d9f420ce7b9ec04de82.svg";